import Color from '@tiptap/extension-color';
import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import Underline from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';

import { FontSizeTextStyle } from './fontSizeExtension';

export interface RichTextEditorExtensionOptions {
  enableLists?: boolean;
  enableUnderline?: boolean;
  enableLinks?: boolean;
  enableHorizontalRule?: boolean;
  enableBlockquote?: boolean;
  enableTextColor?: boolean;
  enableFontSize?: boolean;
}

export function createRichTextEditorExtensions(
  placeholder: string,
  options: RichTextEditorExtensionOptions = {}
) {
  const {
    enableLists = false,
    enableUnderline = false,
    enableLinks = false,
    enableHorizontalRule = false,
    enableBlockquote = false,
    enableTextColor = false,
    enableFontSize = false,
  } = options;

  return [
    StarterKit.extend({
      addExtensions() {
        return (this.parent?.() ?? []).map((extension) =>
          extension.name === 'listItem'
            ? extension.extend({
                addKeyboardShortcuts() {
                  const shortcuts = { ...this.parent?.() };
                  // Tab navigates between authoring fields, including inside lists.
                  delete shortcuts['Tab'];
                  delete shortcuts['Shift-Tab'];
                  return shortcuts;
                },
              })
            : extension
        );
      },
    }).configure({
      heading: false,
      ...(enableLists
        ? {}
        : {
            bulletList: false,
            orderedList: false,
            listItem: false,
          }),
      ...(enableUnderline ? { underline: false } : {}),
      ...(enableLinks ? { link: false } : {}),
      ...(enableHorizontalRule ? {} : { horizontalRule: false }),
      ...(enableBlockquote ? {} : { blockquote: false }),
      codeBlock: false,
      code: false,
      hardBreak: false,
      dropcursor: false,
      gapcursor: false,
      ...(enableTextColor || enableFontSize ? { textStyle: false } : {}),
    }),
    ...(enableUnderline ? [Underline] : []),
    ...(enableLinks
      ? [
          Link.configure({
            openOnClick: false,
            autolink: true,
            linkOnPaste: true,
            validate: (url: string) => /^https?:\/\/|^mailto:/i.test(url),
          }),
        ]
      : []),
    ...(enableTextColor || enableFontSize
      ? [FontSizeTextStyle, Color]
      : []),
    Placeholder.configure({ placeholder }),
  ];
}
